import React from 'react';
import { unmountComponentAtNode } from 'react-dom';

import { renderWithStore } from 'state';
import { ProductReviews } from 'features/productReviews/components';

function initProductReviews (pageState, element) {

	const {
		multiProductSkuChanged, productData, reviewsData, reviewsSummaryData, questionsData
	} = pageState;

	if (element) {

		renderWithStore(
			<ProductReviews
				resetInitialState={multiProductSkuChanged}
				productData={productData}
				reviewsData={reviewsData}
				reviewsSummaryData={reviewsSummaryData}
				questionsData={questionsData}
			/>,
			element
		);

	}

	pageState.reviewsInitialized = true;

}

function unmountProductReviews (element) {

	if (element) {

		unmountComponentAtNode(element);

	}

}
export { unmountProductReviews };
export default initProductReviews;
